import React from 'react';

const WebappTransitionLoader = () => <div className="webappTransitionLoader" aria-label="Loading Spinner" />;

export default WebappTransitionLoader;
